module.exports = __webpack_public_path__ + "img/incoming-gray.fe3402e3.svg";